import { Slide } from '@mui/material';
import type { FunctionComponent } from 'react';
import type { Simplify } from 'type-fest';

import IconButton from '../../generic/Button/IconButton';
import Flex from '../../generic/Flex';
import { icons } from '../../generic/Icon/icons';
import type { BaseToast as ToastType } from '../types';

export type BaseToastProps = Simplify<ToastType & {
  onClose: (id: number) => void;
}>;

/**
 * Simple/base Toast component, upon which all other Toasts
 * are built. Includes the content as well as the close button.
 */
const BaseToast: FunctionComponent<BaseToastProps> = ({
  id,
  type,
  isVisible,
  children,
  content,
  onClose,
}) => (
  <Slide in={isVisible} mountOnEnter unmountOnExit direction="left">
    <div className={`fossa-toast fossa-toast--${type}`}>
      <div className="fossa-toast__content">{content}</div>
      <Flex gap="3px" shrink={0}>
        {children}
        <IconButton
          id={`toast-${id}-close`}
          icon={icons.times}
          onClick={() => onClose(id)}
        />
      </Flex>
    </div>
  </Slide>
);

export default BaseToast;
